import WorkspaceOption from './WorkspaceOption';

export default WorkspaceOption;
